var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.376 12.4153L8.777 19.4813C8.70171 19.5314 8.61423 19.5602 8.52389 19.5645C8.43355 19.5688 8.34373 19.5486 8.264 19.5059C8.18427 19.4632 8.1176 19.3997 8.07111 19.3221C8.02462 19.2445 8.00005 19.1558 8 19.0653V4.93334C8.00005 4.84289 8.02462 4.75416 8.07111 4.67658C8.1176 4.599 8.18427 4.53548 8.264 4.49279C8.34373 4.45011 8.43355 4.42984 8.52389 4.43416C8.61423 4.43849 8.70171 4.46723 8.777 4.51734L19.376 11.5833C19.4445 11.629 19.5006 11.6909 19.5395 11.7634C19.5783 11.836 19.5986 11.917 19.5986 11.9993C19.5986 12.0816 19.5783 12.1627 19.5395 12.2352C19.5006 12.3078 19.4445 12.3697 19.376 12.4153Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayicon);
export default __webpack_public_path__ + "static/media/Play icon.b851d2d69eb73ec45e9b2ea9332854bc.svg";
export { ForwardRef as ReactComponent };